import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RewardsPanel from '../components/RewardsPanel';

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const displayName = user?.name || 'Player';
  const initial = (user?.name || user?.email || '?')[0].toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Your account</span>
        <h1 className="page-title section-gap">Profile</h1>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="flex items-center gap-4">
            <span
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-xl font-black text-white"
              style={{ background: 'linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-accent) 100%)' }}
            >
              {initial}
            </span>
            <div className="min-w-0">
              <p className="truncate text-lg font-black text-slate-900">{displayName}</p>
              {user?.email && <p className="truncate text-sm text-slate-500">{user.email}</p>}
            </div>
          </div>

          <button
            type="button"
            onClick={handleLogout}
            className="mt-6 w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 sm:w-auto"
          >
            Log out
          </button>
        </div>

        <div className="mt-8">
          <RewardsPanel />
        </div>
      </div>
    </div>
  );
}
